import React from "react"

import { styled } from "@mui/styles"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { Attachments } from "./Attachments"
import { DropArea } from "./DropArea"
import { Files } from "../../types/Files"

interface IProps {
  files: Files,
  fileCount: number,
  maxAttachments: number,
  maxAttachmentSize: number,
  supportedFileTypes: string[],
  supportedFileTypesLabel: string,
  setFiles: (files: Files) => void,
  onRemove: (index: number) => void,
}

export const Form = ({
  files,
  fileCount,
  maxAttachments,
  maxAttachmentSize,
  supportedFileTypes,
  supportedFileTypesLabel,
  setFiles,
  onRemove
}: IProps) => {
  const { i18n } = useTranslations()

  return <Wrapper>
    <div>
      <div>{i18n("General:MaximumAttachments")}: {maxAttachments}</div>
      <div>{i18n("General:Format")}: {supportedFileTypesLabel}</div>
    </div>

    <DropArea
      fileCount={fileCount}
      maxAttachments={maxAttachments}
      setFiles={setFiles}
    />

    <Attachments
      files={files}
      fileCount={fileCount}
      maxAttachments={maxAttachments}
      maxAttachmentSize={maxAttachmentSize}
      supportedFileTypes={supportedFileTypes}
      onRemove={onRemove}
    />

  </Wrapper>
}

const Wrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "2rem"
})




